import React from "react";
import PropTypes from "prop-types";

import {
	timestampToDate,
	makePrettyDate,
} from "apps/messenger/util/helpers";

import "apps/messenger/components/MainWindow/MessagePane/Timestamp.scss";

const Timestamp = ({ timestamp }) => (
	<time className="messenger-message-timestamp">
		{makePrettyDate(timestampToDate(timestamp))}
	</time>
);

Timestamp.propTypes = {
	timestamp: PropTypes.number.isRequired,
};

export default Timestamp;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/MainWindow/MessagePane/Timestamp.jsx